const COOKIE_NAME = 'cookiePreferences';
const COOKIE_MAX_AGE = 15552000; // ~180 days / 6 months

function isConsentTimeExpired(inConsentTime) {
    const consentTime = new Date(inConsentTime);
    if (Number.isNaN(consentTime.getTime())) {
        return true;
    }

    const pastDate = new Date();
    pastDate.setMonth(pastDate.getMonth() - 6);

    return consentTime < pastDate;
}

export function getParentCookieDomain() {
    const hostname = window.location.hostname;

    if (
        hostname === 'localhost' ||
        hostname === '127.0.0.1' ||
        !hostname.includes('.')
    ) {
        return null;
    }

    const parts = hostname.split('.');
    return '.' + parts.slice(-2).join('.');
}

export function readRawCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

function parsePreferences(raw) {
    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
}

export function saveCookiePreferences(preferences) {
    const domain = getParentCookieDomain();
    const value = JSON.stringify(preferences);

    if (value.includes(';')) {
        return;
    }

    const secure = window.location.protocol === 'https:' ? ';Secure' : '';
    const domainPart = domain ? `;domain=${domain}` : '';

    document.cookie = `${COOKIE_NAME}=${value};path=/${domainPart};max-age=${COOKIE_MAX_AGE};SameSite=Lax${secure}`;
}

export function getCookiePreferences() {
    return parsePreferences(readRawCookie(COOKIE_NAME));
}

export function hasCookieAccepted(cookieName) {
    const cookiePreferences = getCookiePreferences();

    if (
        !cookiePreferences ||
        !cookiePreferences.consentTime ||
        isConsentTimeExpired(cookiePreferences.consentTime)
    ) {
        return false;
    }

    return cookiePreferences[cookieName] === true;
}
